import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import commonGenerateNetReport from './Report.service';

export default function useCommonGenerateNetReport<T>(
  URL = '',
  message: string,
  description: string,
  isIntl?: boolean,
  isPocReport?: boolean,
) {
  const intl = (text: string) => useIntl().formatMessage({ id: text });
  const mutation = useMutation(
    (obj: T) => commonGenerateNetReport(URL, obj, isPocReport),
    {
      onSuccess() {
        notification.success({
          message: isIntl ? intl(message) : message,
          description: isIntl ? intl(description) : description,
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
